import { Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import { PageLoader } from './components/UI';
import { useAuth } from './context/AuthContext';
import AdminUsersPage from './pages/AdminUsersPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AppSettingsPage from './pages/AppSettingsPage';
import AuditLogsPage from './pages/AuditLogsPage';
import CollectionPage from './pages/CollectionPage';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import { NotFoundPage, UnauthorizedPage } from './pages/SystemPages';
import VillagePage from './pages/VillagePage';

function ProtectedLayout() {
  const { user, adminProfile, loading } = useAuth();
  if (loading) return <div className="fullscreen-loader"><PageLoader label="Secure admin session loading…" /></div>;
  if (!user || !adminProfile) return <Navigate to="/login" replace />;
  return <AppLayout />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="village" element={<VillagePage />} />
        <Route path="app-settings" element={<AppSettingsPage />} />
        <Route path="content/:moduleKey" element={<CollectionPage />} />
        <Route path="admins" element={<AdminUsersPage />} />
        <Route path="audit-logs" element={<AuditLogsPage />} />
        <Route path="unauthorized" element={<UnauthorizedPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
